/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext } from "react";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { DefaultAddImageButton } from "cms/images/image-selector/exported/add-image-button";
import { DefaultImageSelectorDisplayComponent } from "cms/images/image-selector/exported/display/display-panel";

const ImageSelectorDisplay = (props) => {
    const { defaultImageSelectorWidth, defaultImageSelectorHeight } = props;
    const {
        setOpen,
        image,
        onSaveImage,
        onImageUploaded,
        DisplayComponent,
        AddButtonComponent,
    } = useContext(ImageEditContext);

    const hasImage = image && image?.url;

    return (
        <Fragment>
            {hasImage &&
                <>
                    {DisplayComponent &&
                        <DisplayComponent
                            image={image}
                        />
                    }
                    {!DisplayComponent &&
                        <DefaultImageSelectorDisplayComponent
                            image={image}
                            defaultImageSelectorWidth={defaultImageSelectorWidth}
                            defaultImageSelectorHeight={defaultImageSelectorHeight}
                        />
                    }
                </>
            }
            {!hasImage &&
                <Fragment>
                    {AddButtonComponent &&
                        <AddButtonComponent
                            // this dynamic Component allows you to pass in your own React component as an add button
                            image={image}
                            setOpen={setOpen}
                            onClick={() => setOpen(true)}
                            onImageUploaded={onImageUploaded.bind(this)}
                            onSaveImage={onSaveImage}
                        />
                    }
                    {!AddButtonComponent &&
                        <DefaultAddImageButton setOpen={setOpen} />
                    }
                </Fragment>
            }
        </Fragment>
    );
};

export { ImageSelectorDisplay };
